import type { ModelAttachmentTypes, ModelTextStyle } from "@/store/clientApi";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TemplateSlice {
  templateId?: number;
  name: string;
  modelType?: "horse_shoe" | "full_palate";
  attachments?: ModelAttachmentTypes;
  isHollow: boolean;
  textStyle?: ModelTextStyle;
}

const initialState: TemplateSlice = {
  name: "",
  isHollow: false
};

const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    resetTemplate() {
      return { ...initialState };
    },
    setTemplate(state, action: PayloadAction<TemplateSlice>) {
      return action.payload;
    },
    setName(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    setModelType(state, action: PayloadAction<"horse_shoe" | "full_palate" | undefined>) {
      state.modelType = action.payload;
    },
    setModelAttachmentType(state, action: PayloadAction<ModelAttachmentTypes | undefined>) {
      state.attachments = action.payload;
    },
    setIsHollow(state, action: PayloadAction<boolean>) {
      state.isHollow = action.payload;
    },
    setIsAffixText(state, action: PayloadAction<boolean>) {
      if (action.payload) {
        state.textStyle = "embossed";
      } else {
        state.textStyle = undefined;
      }
    },
    setTextStyle(state, action: PayloadAction<ModelTextStyle | undefined>) {
      state.textStyle = action.payload;
    }
  },
  selectors: {
    selectTemplate(state) {
      return state;
    },
    selectTemplateName: (state) => state.name,
    selectModelType: (state) => state.modelType,
    selectTemplateAttachments: (state) => state.attachments,
    selectTemplateIsHollow: (state) => state.isHollow,
    selectTemplateId: (state) => state.templateId,
    selectTemplateTextStyle: (state) => state.textStyle,
    selectIsNameInvalid: (state) => state.name === ""
  }
});

export const {
  setName: setName,
  setModelType,
  setModelAttachmentType,
  setIsHollow,
  setIsAffixText,
  setTextStyle,
  resetTemplate,
  setTemplate
} = templateSlice.actions;
export const {
  selectTemplate,
  selectModelType,
  selectTemplateAttachments,
  selectTemplateId,
  selectTemplateIsHollow,
  selectTemplateName,
  selectTemplateTextStyle,
  selectIsNameInvalid
} = templateSlice.selectors;
export { initialState as defaultTemplate };
export type { TemplateSlice };
export default templateSlice.reducer;
